import React from "react";
import ListaMundialContainer from "./ListaMundialContainer";

const ListaMundial = (props) => {
  return (
      <ListaMundialContainer location={props.location} history={props.history} match={props.match}/>
  );
};

export default ListaMundial;
